/**
 * Mobile Navigation Context
 * Controls mobile sidebar and panels visibility
 */
import { createContext, useContext, useState, useEffect } from 'react';

const MobileNavContext = createContext();

export const MobileNavProvider = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [watchlistOpen, setWatchlistOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Close sidebar when clicking outside on mobile
  const closeSidebar = () => setSidebarOpen(false);
  const closeWatchlist = () => setWatchlistOpen(false);

  return (
    <MobileNavContext.Provider value={{
      sidebarOpen,
      setSidebarOpen,
      watchlistOpen,
      setWatchlistOpen,
      isMobile,
      isTablet,
      closeSidebar,
      closeWatchlist
    }}>
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileNav = () => {
  const context = useContext(MobileNavContext);
  if (!context) {
    throw new Error('useMobileNav must be used within MobileNavProvider');
  }
  return context;
};
